import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'
import { addToCartButtonFields, PRODUCT_PAGES, titleFields } from './_shared-library'

/** Heading, optional category tabs as pastel pills (v1), then a swipe row of product cards. */
export const schema: ComponentSchema = {
  type: 'product-slider',
  label: 'Product slider',
  description: 'A swipe row of product cards, optionally with category tabs.',
  supportedPages: PRODUCT_PAGES,
  variants: [
    {
      id: 'v1',
      label: 'Category tabs',
      fields: [{
        key: 'tabs',
        label: 'Tabs',
        type: 'array',
        itemSchema: [
          { key: 'label', label: 'Tab label', type: 'string' },
          { key: 'categoryId', label: 'Category', type: 'category-select' },
        ],
      }],
    },
    { id: 'v2', label: 'Single row' },
  ],
  commonFields: [...titleFields('Popular right now', 'Pick a shelf: toys, baby care or school.'), ...addToCartButtonFields, ...SECTION_STYLE_FIELDS],
}
